import React from 'react';
import styled from 'styled-components';

const PurposeSectionContainer = styled.div`
  margin-bottom: 82px;
  text-align: center;
`;

const PurposeSectionInner = styled.div`
  // display: flex;
  max-width: 720px;
  padding: 0 25px;
  margin: 0 auto;
`;

const Content = styled.div`
  flex: 1;
`;

const MainLabel = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
`;

const PurposeItem = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.36px;
  margin-bottom: 22px;
`;

const MainImg = styled.div`
  img {
    height: 220px;
  }
`;

const Description = styled.div`
  width: 440px;
  margin: 0 auto;
  padding-top: 44px;
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  margin-top: 4px;
`;

function PurposeSection({ input }) {
  return (
    <PurposeSectionContainer>
      <PurposeSectionInner>
        <MainImg>
          <img src={input.primary.image.url} />
        </MainImg>
        <Description>{input.primary.description.text}</Description>
      </PurposeSectionInner>
    </PurposeSectionContainer>
  );
}

export { PurposeSection };

// <Content>
//          <MainLabel>TrustToken serves three purposes:</MainLabel>
//        </Content>
// {input.items.map((item, i) => {
//             return (
//               <PurposeItem key={i}>
//                 <div>{item.description.text}</div>
//               </PurposeItem>
//             );
//           })}
